import { type Article } from "../types/article";

export const getPublishedArticles = (articles: Article[]) =>
  articles.filter((article) => article.published);
